import React from "react";
import DailogueRms from "./DailogueRms";
import { CircularProgress, Grid, Typography } from "@material-ui/core";
import QuotesCard from "./QuotesCard";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { LOCAL_STORAGE_KEY, baseUrlRate } from "../../../config";
import { path } from "../../../order_managment/constants/apiPath";
import { useEffect } from "react";
import { getUserData } from "../../common/utility/Utils";
import { useRef } from "react";

const FCL_QuoteDetails = () => {
  const [loading, setLoading] = useState(false);
  const [freightRate, setfreightRate] = useState([]);
  const [quoteArr, setQuoteArr] = useState([]);
  const [quoteResult, setQuoteResult] = useState({});
  const [totalCount, setTotalCount] = useState("");
  const [dailogueOpen, setDailogueOpen] = useState(false);
  const [clicked, setClicked] = useState(null);
  const [loadingbutton, setLoadingbutton] = useState(null);

  const location = useLocation();
  const objref = useRef([]);
  console.log("objref", objref.current);
  console.log("quoteResultfaee", quoteResult);

  const disableQuoteButton = (index) => {
    // setButtonDisable(index);
    let tempo = [...freightRate];

    const tempFreightRate = {
      ...freightRate[index],
      buttonDisable: true,
      quoteBookingId: quoteResult?.quote_BookingId,
    };
    tempo[index] = tempFreightRate;
    setfreightRate(tempo);
    // setfreightRate([...freightRate, (freightRate[index])]);
    // console.log("Temp Data: ", tempFreightRate);
    // setfreightRate(tempFreightRate)
  };

  const getRateFreight = async () => {
    setLoading(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    console.log("location.state", location.state);
    const url = `${baseUrlRate}${path.GET_FCL_QUOTE}`;
    const body = {
      fromCode: location.state?.origin?.originCode ?? "",
      toCode: location.state?.destination.destinationCode ?? "",
    };
    axios
      .post(url, body, {
        headers: header,
      })
      .then((res) => {
        setLoading(false);
        setTotalCount(res?.data?.count);
        setfreightRate(res.data?.quotes ?? res?.data?.fclPricingDetails ?? []);
        let emptyArr = [];
        res?.data?.fclPricingDetails.map(() => {
          emptyArr.push({});
        });
        setQuoteArr(emptyArr);
        console.log("resss", quoteArr);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const createQuote = async (item, index) => {
    console.log("freightRateeeee");
    setLoadingbutton(index);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const url = `${baseUrlRate}${path.CREATE_FCL_QUOTE}`;

    const body = {
      bookingMadeByUserId: data.user_name.split("@")[0],
      bookingMadeForCompanyCode:
        location.state?.userType === "SALES"
          ? location.state?.saleCompanyCode?.organizationCode
          : location.state?.companyCode,
      emailIdOfUser: data.user_name,
      commodity: location.state.commodity,
      isGP20ContainerSelected:
        objref.current?.[0]?.gP20 && objref.current?.[1]?.gP20 === 0
          ? false
          : objref.current?.[0]?.gP20 ?? false,
      isGP40ContainerSelected:
        objref.current?.[0]?.gP40 && objref.current?.[1]?.gP40 === 0
          ? false
          : objref.current?.[0]?.gP40 ?? false,
      isHQ40ContainerSelected:
        objref.current?.[0]?.hQ40 && objref.current?.[1]?.hQ40 === 0
          ? false
          : objref.current?.[0]?.hQ40 ?? false,
      isHQ45ContainerSelected:
        objref.current?.[0]?.hQ45 && objref.current?.[1]?.hQ45 === 0
          ? false
          : objref.current?.[0]?.hQ45 ?? false,
      isNOR40ContainerSelected:
        objref.current?.[0]?.nor40 && objref.current?.[1]?.nor40 === 0
          ? false
          : objref.current?.[0]?.nor40 ?? false,
      gP20ContainerCount: objref.current?.[1]?.gP20 ?? 0,
      gP40ContainerCount: objref.current?.[1]?.gP40 ?? 0,
      hQ40ContainerCount: objref.current?.[1]?.hQ40 ?? 0,
      hQ45ContainerCount: objref.current?.[1]?.hQ45 ?? 0,
      noR40ContainerCount: objref.current?.[1]?.noR40 ?? 0,
      gP20ContainerRate: objref.current?.[2]?.gP20 ?? 0,
      gP40ContainerRate: objref.current?.[2]?.gP40 ?? 0,
      hQ40ContainerRate: objref.current?.[2]?.hQ40 ?? 0,
      hQ45ContainerRate: objref.current?.[2]?.hQ45 ?? 0,
      noR40ContainerRate: objref.current?.[2]?.noR40 ?? 0,
      isInsuraceOpted: JSON.parse(location.state.isInsuraceOpted),
      isCustomClearaceOpted: JSON.parse(location.state.isCustomClearaceOpted),
      isHazardous: JSON.parse(location.state.isHazardous),
      signature: freightRate[index].signature,
      cY_Closing: freightRate[index].cY_Closing,
      carrier: freightRate[index].carrier,
      commodityType: freightRate[index].commodity,
      destination: freightRate[index].destination,
      etd: freightRate[index].etd,
      effectiveDate: freightRate[index].effectiveDate,
      expiringDate: freightRate[index].expiringDate,
      mode: freightRate[index].mode === "" ? "CY" : freightRate[index].mode,
      pod: freightRate[index].pod,
      pol: freightRate[index].pol,
      routing: freightRate[index].routing,
      tT_to_POD: freightRate[index].tT_to_POD,
      via: freightRate[index].via,
    };

    axios
      .post(url, body, {
        headers: header,
      })
      .then((res) => {
        objref.current = [];
        setLoadingbutton(null);
        setQuoteResult(res?.data ?? res?.fclPricingDetails ?? {});
        let temp = [...quoteArr];
        // temp.push(res?.data ?? res?.fclPricingDetails ?? {});
        console.log("quoteArrdbgfhb", res);

        temp[index] = res?.data;
        setQuoteArr(temp);
        console.log("quoteArr", quoteArr);
        // setQuoteId(res.data.quote_BookingId ?? "");
        setDailogueOpen(true);
        disableQuoteButton(index);
      })
      .catch((err) => {
        setLoadingbutton(null);
        setQuoteResult({});
        console.log(err);
      });
  };

  useEffect(() => {
    getRateFreight();
  }, []);

  return (
    <div className="test">
      <Grid container style={{ flexDirection: "row" }}>
        {dailogueOpen ? (
          <DailogueRms
            status={location.state.status}
            dailogueOpen={dailogueOpen}
            setDailogueOpen={setDailogueOpen}
            quoteResult={quoteResult}
            details={location.state}
          />
        ) : null}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100">
            <CircularProgress size="2rem" />
          </div>
        ) : (
          <>
            {!freightRate.length ? (
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                No data found!
              </Typography>
            ) : (
              <>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: "1.5rem" }}>
                    Available Quote(s) :{" "}
                    <span style={{ fontWeight: "bold", color: "#0069bf" }}>
                      {` ${totalCount}`}
                    </span>
                  </Typography>
                </Grid>
                {freightRate.map((item, index) => {
                  return (
                    <QuotesCard
                      item={item}
                      index={index}
                      setClicked={setClicked}
                      clicked={clicked}
                      createQuote={createQuote}
                      objref={objref.current}
                      freightRate={freightRate}
                      quoteArr={quoteArr}
                      loadingbutton={loadingbutton}
                      key={index}
                    />
                  );
                })}
                {/* <Grid item xs={12}>
            <Paper elevation={3}>
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "red",
                  padding: "0.3rem 0",
                }}
              >
                This Quotation is subject to in and out warehouse charges
              </Typography>
            </Paper>
          </Grid> */}
              </>
            )}
          </>
        )}
      </Grid>
    </div>
  );
};

export default FCL_QuoteDetails;
